import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'

import { showSnackbar } from '@context/SnackbarContext'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import { useSelector, useDispatch } from 'react-redux'
import WebService from '@util/webService'
import { comma } from '@src/util/helper'
import useAlert from '@hooks/useAlert'
import FlatButton from '@components/FlatButton'
import * as ExcelJS from 'exceljs'
import axios from 'axios'
import MyDialog2 from '@components/MyDialog2'
import StateChanger from '@components/StateChanger'
import MyPagination from '@components/MyPagination'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import MobileLabel from '@components/MobileLabel'
import ConfirmDialog from '@components/ConfirmDialog'
import consoleLogger from 'react-terminal-logger/console-logger'
import { EditOutlined } from '@mui/icons-material'
import { truncate } from '@util/helper'
import { TextareaAutosize } from '@mui/base/TextareaAutosize'
import { useAsyncDebounce } from 'react-table'
import ContractDownloader from '@components/ContractDownloader'

const boldFont = {
  fontWeight: 'bold',
}

const selectOptions = [
  { name: 'All', value: '' },
  { name: 'Y', value: 'Y' },
  { name: 'N', value: 'N' },
]
const defPageInfo = { pageNum: 0, pageSize: 10 }
const AdminIndex = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const account = useSelector((state) => state.accountReducer)
  const codes = useSelector((state) => state.codeReducer)
  const productCodes = codes.filter(r => r.codeGroupId === 'R001')
  const bizCodes = codes.filter(r => r.codeGroupId === 'R002')
  const channelCodes= codes.filter(r => r.codeGroupId === 'R003')
  const [records, set_records] = useState([])
  const navigate = useNavigate()
  const location = useLocation()
  const pack = location.state?.pack
  const curLocationRef = useRef(location)
  const docCodes = codes.filter((r) => r.codeGroupId === 'D001')
  const semuCodes = docCodes.filter((r) => r.code.startsWith('DS'))
  const restCodes = docCodes.filter((r) => r.code.startsWith('DG'))
  const recvCodes = codes.filter((r) => r.codeGroupId === 'C001')
  const statCodes = codes.filter((r) => r.codeGroupId === 'C002')
  const { alert, renderAlert } = useAlert()
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState(pack?.data ?? defPageInfo)
  const [termsKey, set_termsKey] = useState(0)
  // 지점 검색용 목록
  const [branches, set_branches] = useState([])
   const [terms, _set_terms] = useState(pack?.data?.terms ?? {})
  const termsRef = useRef(terms)
  const orderRef = useRef({})
  const buttonRef = useRef(null)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const dgRef = useRef()
  const dgRef2 = useRef()
  const remarkRef = useRef()

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };

  // 지점 검색용 목록 조회: 폐점 지점의 기존 계약도 조회해야 하므로 영업 상태와 무관하게 전체
  const fetchBranches = async () => {
    const url = `/branch/list`
    const resp = await WebService.get(url, {})

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    // id=-1 '호실 미배정' ghost 지점 제외
    set_branches(records.filter((r) => r.id > 0))
  }

  const fetchEmptyRooms = async(branchId) => {
    const url = `/room/empty/${branchId}`
    const resp = await WebService.get(url, { })

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    console.log('rooms=>', records)
    return records
  }

  const fetchOrders = async (withPage = true) => {
    const url = `/order/admin`
    const resp = await WebService.get(url, {
      pageNum: withPage ? pageInfo.pageNum : null,
      pageSize: withPage ? pageInfo.pageSize : null,
      terms: JSON.stringify(termsRef.current),
    })

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const totalCount = +repMessage.totalCount
    set_totalCount(totalCount)
    return records
  }


  const onLoad = async () => {
    const records = await fetchOrders()
    if (!records) {
      return
    }
    set_records(records)
  }

  const onSearch = async () => {
    console.log('termsRef=>', termsRef)

    set_pageInfo({
      pageNum: 0,
      pageSize: 10,
    })
  }

  const onRejectClaim = async (order) => {
    const url = '/order/update'
    const data = {
      record: { ...order, claimYn: 'N' },
    }

    const resp = await WebService.post(url, data)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    showSnackbar('취소거절 처리 되었습니다.')
    set_pageInfo({ ...pageInfo })
  }

  const onDownload = async() => {
    const records = await fetchOrders(false)
    if (!records) {
      return
    }
    if(records.length == 0) {
      alert('데이터가 없습니다.')
      return
    }

    // 번호 필드 묶음: 모두 비어 있으면 빈 칸, 아니면 '-' 로 연결
    const joinNum = (...parts) => (parts.every((p) => !p) ? '' : parts.map((p) => p ?? '').join('-'))
    const toDay = (t) => (t ? moment(t).format('YYYY-MM-DD') : '')

    // 계약목록(orders) 필드 기준 컬럼, 주민번호는 다운로드 대상에서 제외
    const xlsxColumns = [
      { kname: '주문번호', width: 18, value: (row) => row.orderNo },
      { kname: '등록일시', width: 20, value: (row) => row.regTime },
      { kname: '상태', width: 10, value: (row) => statCodes.find((r) => r.code === row.statCode)?.name ?? row.statCode },
      { kname: '상호명', width: 20, value: (row) => row.companyName },
      { kname: '대표자명', width: 10, value: (row) => row.repName },
      { kname: '사업자유형', width: 10, value: (row) => bizCodes.find((r) => r.code === row.bizCode)?.name ?? row.bizCode },
      { kname: '업종', width: 14, value: (row) => row.industry },
      { kname: '대표자전화', width: 14, value: (row) => row.repPhone },
      { kname: '담당자명', width: 10, value: (row) => row.contactName },
      { kname: '담당자전화', width: 14, value: (row) => row.contactPhone },
      { kname: '이메일', width: 24, value: (row) => row.email },
      { kname: '주소', width: 40, value: (row) => [row.addr1, row.addr2].filter((s) => s?.trim()).join(' ') },
      { kname: '사업자번호', width: 14, value: (row) => joinNum(row.bizNum1, row.bizNum2, row.bizNum3) },
      { kname: '법인번호', width: 16, value: (row) => joinNum(row.corpNum1, row.corpNum2) },
      { kname: '상품', width: 12, value: (row) => productCodes.find((r) => r.code === row.productCode)?.name ?? row.productCode },
      // id=-1 ghost 지점('호실 미배정')은 지점명으로 쓰지 않음
      { kname: '지점', width: 14, value: (row) => (row.branch?.id > 0 ? row.branch.branchName : '') },
      { kname: '호실', width: 8, value: (row) => (row.roomId > 0 ? row.room?.roomNo : '') },
      { kname: '금액', width: 12, value: (row) => +row.amount },
      { kname: '시작일', width: 12, value: (row) => toDay(row.startTime) },
      { kname: '종료일', width: 12, value: (row) => toDay(row.endTime) },
      { kname: '메일개봉발송', width: 12, value: (row) => row.emailSvcYn },
      { kname: '기장여부', width: 10, value: (row) => row.bookYn },
      { kname: '기장비고', width: 30, value: (row) => row.bookRemark },
      { kname: '유입경로', width: 12, value: (row) => channelCodes.find((r) => r.code === row.channelCode)?.name ?? row.channelCode },
      { kname: '비고', width: 30, value: (row) => row.remark },
      { kname: '수정일시', width: 20, value: (row) => row.uptTime },
    ]

    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('계약목록')
    worksheet.columns = xlsxColumns.map((col) => ({
      header: col.kname,
      width: col.width,
    }))
    records.forEach((row) => {
      worksheet.addRow(xlsxColumns.map((col) => col.value(row) ?? ''))
    })
    // 금액 컬럼은 천 단위 콤마 서식
    const amountColIdx = xlsxColumns.findIndex((col) => col.kname === '금액') + 1
    worksheet.getColumn(amountColIdx).numFmt = '#,##0'

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      let filename = `계약목록_${moment().format('YYYYMMDD')}.xlsx`

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }

  const onDelete = async(orderId) => {
    const url = `/order/${orderId}`
    const resp = await WebService.delete(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    showSnackbar('삭제되었습니다.')
    set_pageInfo({...pageInfo})
  }

  // 계약 상세로 이동: 목록의 검색조건/페이지를 pack 으로 넘겨 복귀 시 유지
  const goView = (item) => {
    navigate('/admin/order/view', {
      state: {
        order: item,
        pack: {
          url: window.location.pathname,
          data: {
            pageInfo: pageInfo,
            terms: terms
          }
        },
      },
    })
  }

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_terms({})
      set_termsKey(termsKey + 1)
      onLoad()
    }
  }, [location])

  useEffect(() => {
    if (!account?.user?.id) {
      navigate('/login')
    } else {
      onLoad()
    }
  }, [pageInfo])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
}, []);

  useEffect(() => {
    fetchBranches()
  }, [])

  const Remark = () => {
    const [order, set_order] = useState(orderRef.current)

    const onSubmit = async () => {
      const url = '/order/update/remark'
      const data = {
        remark:order.remark
      }
      const resp = await WebService.post(url, data, {orderId: order.id})
      if(resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      else {
        showSnackbar('저장되었습니다.')
        dgRef.current.close()
        set_pageInfo({...pageInfo})
      }
    }
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ fontWeight: 'bold' }}>
          <Typography>주문번호: {orderRef.current.orderNo}</Typography>
          <Typography>등록일시: {orderRef.current.regTime}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs>
          <TextField
            rows={5}
            fullWidth
            multiline
            label={'비고'}
            defaultValue={order.remark}
            onChange={ e => {
              order.remark = e.target.value
            }}
          />
        </Grid>
        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
          <Button variant='contained'
            onClick={onSubmit}
          >저장</Button>
        </Grid>
      </Grid>
    )
  }


  const Room = () => {
    const [rooms, set_rooms] = useState([])
    const [roomId, set_roomId] = useState()
    const fillRooms = async () => {
      // 주문의 지점 기준으로 빈 호실 조회
      const records = await fetchEmptyRooms(orderRef.current.branchId)
      if(records) {
        set_rooms(records)
      }
    }

    const onSubmit = async () => {
      const url = '/order/update/room'
      const orderId = orderRef.current.id
      console.log('roomId=>', roomId)
      console.log('orderId=>', orderId)
      const resp = await WebService.post(url, {}, {orderId: orderRef.current.id, roomId: roomId})
      if(resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      else {
        showSnackbar('저장되었습니다.')
        dgRef2.current.close()
        set_pageInfo({...pageInfo})
      }
    }

    useEffect(() => {
      fillRooms()
    }, [])

    return (
      <div style={{marginTop:10}}>
        <Grid container spacing={2} >
          <Grid item xs={12} style={{ fontWeight: 'bold' }}>
            <Typography>주문정보: {orderRef.current.orderNo}</Typography>
            <Typography>지점: {orderRef.current.branch?.branchName}</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id='roomId'>호실선택</InputLabel>
              <Select
                labelId='roomId'
                label='호실'
                value={roomId}
                onChange={async (e) => {
                  set_roomId(e.target.value)
                }}
              >
                {rooms.map((l, index) => {
                  return (
                    <MenuItem key={index} value={l.id}>
                      {l.roomNo}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            <Button
              variant='contained'
              disabled= {roomId ? false : true}
              onClick={onSubmit}
            >저장</Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  return (
    <>
      <div
        style={{
          paddingTop: isMobile ? 50 : 30,
          paddingBottom: 50,
          minHeight: '75vh',
        }}
      >
        {renderAlert()}
        <MyDialog2 title={'비고'} ref={dgRef} component={<Remark />} windowWidth='sm' />
        <MyDialog2 title={'호실선택'} ref={dgRef2} component={<Room />} windowWidth='sm' />
        <Container>
          <Grid container spacing={2} style={{ alignItems: 'center' }}>
            <Grid
              item
              xs={12}
              style={{ backgroundColor: '#fff', color: '#000', alignItems: 'center', paddingBottom: 16 }}
            >
              <Typography style={boldFont} variant='h5'>계약목록</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} key={termsKey}>
                <Grid item xs={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                    <DatePicker
                      label={'계약시작일 From'}
                      value={terms.from ?? null}
                      inputFormat='YYYY-MM-DD'
                      onChange={(newValue) => {
                        const dtime = moment(new Date(newValue))
                        const d = dtime.format('YYYY-MM-DD')
                        set_terms({ ...terms, from: d })
                      }}
                      renderInput={(params) => <TextField fullWidth size='small' {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                    <DatePicker
                      label={'계약시작일 To'}
                      value={terms.to ?? null}
                      inputFormat='YYYY-MM-DD'
                      onChange={(newValue) => {
                        const dtime = moment(new Date(newValue))
                        const d = dtime.format('YYYY-MM-DD')
                        set_terms({ ...terms, to: d })
                      }}
                      renderInput={(params) => <TextField fullWidth size='small' {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                    <DatePicker
                      label={'계약종료일 From'}
                      value={terms.from2 ?? null}
                      inputFormat='YYYY-MM-DD'
                      onChange={(newValue) => {
                        const dtime = moment(new Date(newValue))
                        const d = dtime.format('YYYY-MM-DD')
                        set_terms({ ...terms, from2: d })
                      }}
                      renderInput={(params) => <TextField fullWidth size='small' {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                    <DatePicker
                      label={'계약종료일 To'}
                      value={terms.to2 ?? null}
                      inputFormat='YYYY-MM-DD'
                      onChange={(newValue) => {
                        const dtime = moment(new Date(newValue))
                        const d = dtime.format('YYYY-MM-DD')
                        set_terms({ ...terms, to2: d })
                      }}
                      renderInput={(params) => <TextField fullWidth size='small' {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    placeholder='대표자명'
                    defaultValue={terms.repName}
                    onChange={(e) => {
                      terms.repName = e.target.value
                      termsRef.current = terms
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    placeholder='대표자전화번호'
                    defaultValue={terms.repPhone}
                    onChange={(e) => {
                      terms.repPhone= e.target.value
                      termsRef.current = terms
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    placeholder='주문번호'
                    defaultValue={terms.orderNo}
                    onChange={(e) => {
                      terms.orderNo = e.target.value
                      termsRef.current = terms
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel id='bid'>진행상태</InputLabel>
                    <Select
                      labelId='bid'
                      label='진행상태'
                      value={terms.statCode}
                      onChange={async (e) => {
                        set_terms({ ...terms, statCode: e.target.value })
                      }}
                    >
                      {statCodes.map((l, index) => {
                        return (
                          <MenuItem key={index} value={l.code}>
                            {l.name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    placeholder='회사명'
                    defaultValue={terms.companyName}
                    onChange={(e) => {
                      terms.companyName= e.target.value
                      termsRef.current = terms
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    placeholder='사업자등록번호'
                    defaultValue={terms.bizNum}
                    onChange={(e) => {
                      terms.bizNum = e.target.value
                      termsRef.current = terms
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel id='branchId'>지점</InputLabel>
                    <Select
                      labelId='branchId'
                      label='지점'
                      value={terms.branchId ?? ''}
                      onChange={(e) => {
                        // 빈 값이면 전체 지점
                        set_terms({ ...terms, branchId: e.target.value })
                      }}
                    >
                      <MenuItem value=''>전체</MenuItem>
                      {branches.map((b) => (
                        <MenuItem key={b.id} value={String(b.id)}>
                          {b.branchName}{b.hqYn === 'Y' ? ' (본점)' : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2} >
                    <Grid item xs={12} md={4}>
                      <Button
                        fullWidth
                        variant='contained'
                        onClick={() => {
                          set_terms({})
                          set_termsKey(termsKey + 1)
                        }}
                      >
                        검색초기화
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Button fullWidth variant='contained' onClick={onDownload} >
                        다운로드
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Button fullWidth variant='contained' onClick={onSearch} ref={buttonRef}>
                        찾기
                      </Button>
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider style={{ marginTop: 5, marginBottom: 5 }} />
            </Grid>
            {isMobile ? null : (
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Grid container spacing={0} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Grid item xs={12} md={2}>
                    <Typography style={boldFont}>주문정보</Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography style={boldFont}>계약자정보</Typography>
                    {/* <Typography style={boldFont}>대표자</Typography> */}
                    {/* <Typography style={boldFont}>사업자유형</Typography> */}
                    {/* <Typography style={boldFont}>주소</Typography> */}
                    {/* <Typography style={boldFont}>전화</Typography> */}
                    {/* <Typography style={boldFont}>이메일</Typography> */}
                  </Grid>
                  <Grid item xs md={2}>
                    <Typography style={boldFont}>상품정보</Typography>
                  </Grid>
                  <Grid item xs md>
                    <Typography style={boldFont}>부가서비스</Typography>
                  </Grid>
                  <Grid item xs md>
                    <Typography style={boldFont}>기장</Typography>
                  </Grid>
                  <Grid item xs md>
                    <Typography style={boldFont}>유입경로</Typography>
                  </Grid>
                  <Grid item xs md>
                    <Typography style={boldFont}>비고</Typography>
                  </Grid>
                  <Grid item xs md>
                    <Typography style={boldFont}>관리</Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {records.length > 0
              ? records.map((item, idx) => (
                  <Grid item xs={12} key={item.id} onMouseOver={() => (orderRef.current = item)}>
                    <Grid
                      container
                      spacing={1}
                      key={idx}
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                      <Grid item xs={12} md={2}>
                        <MobileLabel label='[주문번호]' />
                        <Typography variant='body2' style={{fontWeight:'bold'}}>{item.orderNo}</Typography>
                        <Typography variant='body2'>{item.regTime}</Typography>
                      </Grid>
                      <Grid item xs={12} md={3} style={{cursor:'pointer'}}
                        onClick={() => goView(item)}
                      >
                        <MobileLabel label='[계약자정보]' />
                        <Typography variant='body2' style={{fontWeight:'bold'}}><span style={{fontWeight:'bold'}}>상호명</span>: {item.companyName}</Typography>
                        <Typography variant='body2'>대표자명: {item.repName}</Typography>
                        <Typography variant='body2'>
                          유형:{bizCodes.find(r => r.code ===item.bizCode)?.name}
                        </Typography>
                        <Typography variant='body2'>주소: {item.addr1} {item.addr2}</Typography>
                        <Typography variant='body2'>대표자전화: {item.repPhone} </Typography>
                        <Typography variant='body2'>이메일: {item.email} </Typography>
                        <Typography variant='body2'>사업자번호: {item.bizNum1}-{item.bizNum2}-{item.bizNum3} </Typography>
                        <Typography variant='body2'>법인번호: {item.corpNum1}-{item.corpNum2} </Typography>
                      </Grid>
                      <Grid item xs={12} md={2} style={{cursor:'pointer'}}
                        onClick={() => goView(item)}
                      >
                        <MobileLabel label='[상품]' />
                        <Typography variant='body2' style={{ marginBottom: 5, fontWeight: 'bold' }}>
                          {productCodes.find(r => r.code === item.productCode)?.name}
                        </Typography>
                        {/* 상품상세: 괄호 안에 10자까지만 표시, 마우스를 올리면 전체 내용 */}
                        {item.productDetail ? (
                          <Typography variant='body2' style={{ marginBottom: 5 }} title={item.productDetail}>
                            ({truncate(item.productDetail, 10)})
                          </Typography>
                        ) : null}
                        <Typography variant='body2' style={{ marginBottom: 5 }}>
                          {/* id=-1 ghost 지점('호실 미배정')은 지점명으로 쓰지 않음 */}
                          {item.branch?.id > 0 ? item.branch.branchName : '지점 미지정'}
                          {item.roomId > 0 ? ` ${item.room?.roomNo} 호` : ' 호실 미배정'}
                        </Typography>

                        <Typography variant='body2' style={{ marginBottom: 5 }}>
                          금액: {comma(item.amount)}
                        </Typography>
                        <Typography variant='body2' style={{ marginBottom: 5 }}>
                          시작일: {moment(item.startTime).format('YYYY-MM-DD')}
                        </Typography>
                        <Typography variant='body2'>
                          종료일: {moment(item.endTime).format('YYYY-MM-DD')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md>
                        <MobileLabel label='[서비스]' />
                        {/* 열 폭이 좁아 값이 다음 줄로 넘어가지 않도록 줄바꿈 금지 */}
                        <Typography variant='body2' style={{ whiteSpace: 'nowrap' }}>
                          메일개봉발송: {item.emailSvcYn}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md>
                        <MobileLabel label='[기장]' />
                        <Typography variant='body2'>
                          {item.bookYn}
                        </Typography>
                        {item.bookRemark ? (
                          <Typography variant='body2' title={item.bookRemark}>
                            {truncate(item.bookRemark, 10)}
                          </Typography>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md>
                        <MobileLabel label='[유입경로]' />
                        <Typography variant='body2'>
                          {channelCodes.find(r => r.code === item.channelCode)?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md>
                        <MobileLabel label='[비고]' />
                        <Typography variant='body2'>
                          {truncate(item.remark, 10)}
                          <IconButton onClick={() => dgRef.current.open()}>
                              <EditOutlined />
                            </IconButton>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md>
                        {/* 자유결제(P100)는 계약서가 없으므로 계약서 다운로드 버튼을 숨김 */}
                        {item.productCode === 'P100' ? null : (
                          <div style={{marginTop:5}}>
                            <ContractDownloader order={item} />
                          </div>
                        )}
                        <div style={{marginTop:5}}>
                          <StateChanger record={item} tbl={'orders'} callback={(statCode) => {
                            const new_data = [...records]
                            const found = new_data.find(r => r.id === item.id)
                            found.statCode = statCode
                            set_records(new_data)
                          }}/>
                        </div>
                      {/* 자유결제(P100)는 호실을 배정하지 않음 */}
                      {item.productCode === 'P100' ? null : (
                        <div style={{marginTop:5}}>
                          <Button fullWidth onClick={() => dgRef2.current.open()}>
                            호실변경
                          </Button>
                        </div>
                      )}
                        <div style={{marginTop:5}}>
                          <ConfirmDialog
                            btn={<FlatButton fullWidth color={'error'}>삭제</FlatButton>}
                            title={'주의'}
                            content={'삭제 하시겠습니까?'}
                            bc={'error'}
                            preHandle={async () => {
                              return true
                            }}
                            perform={() => {
                              onDelete(item.id)
                            }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                ))
              : null}
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <MyPagination totalCount={totalCount} pageInfo={pageInfo} set_pageInfo={set_pageInfo} />
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  )
}

export default AdminIndex
